<template lang="pug">
#unsupported-agent
  #pc.d-flex.align-items-center.justify-content-center(v-if="appmode == 'pc'")
    .box.box-margin
      .box-body.p-4
        .title.mb-4
          span.unsupported お使いのブラウザはサポートされていません
        p.message
          span 推奨ブラウザのGoogle Chromeをインストールして頂き、
          br
          | Chromeブラウザにてアクセスしなおしてください。
        .chrome-download
          a.download(href="https://www.google.com/intl/ja/chrome/")
            button.btn(type="button") Chromeをダウンロード

  #mobile(v-if="appmode == 'mobile'")
    .p-4
      p.title.mb-4 お使いのブラウザはサポートされていません
      p.message 推奨ブラウザのGoogle Chromeをインストールして頂き、Chromeブラウザにてアクセスしなおしてください。
      .chrome-download
        a.download(href="https://www.google.com/intl/ja/chrome/")
          button.btn(type="button") Chromeをダウンロード
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

/**
 * ### サポート外ブラウザ画面コンポーネント
 */
@Component
export default class UnsupportedAgent extends Vue {
  /** アプリモード。storeのgetterから値を取得する */
  @Getter("appMode") appmode!: string;
}
</script>

<style lang="scss" scoped>
@import "../../styles/pc/_colors.scss";
@import "../../styles/pc/_mixin.scss";

#unsupported-agent {
  word-break: break-all;

  #pc {
    height: 100vh;
    width: 100vw;
    background-color: $bg-gray !important;

    .box {
      width: 560px;
      .title {
        .unsupported {
          font-size: 1.55rem;
        }
      }
    }
  }

  #mobile {
    background-color: $bg-default !important;

    .title {
      color: rgba(51, 51, 51, 1);
      font-size: 1.4rem;
      font-weight: bold;
    }
  }
}
</style>
